import { Component, OnInit, Inject, PLATFORM_ID, signal, inject, input, computed } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { PaymentResponseData } from '../../../../core/models/order-payload.model';
import { NgxBarcode6 } from 'ngx-barcode6';
import { TenantConfigService } from '../../../../core/config/tenant-config';
import { SafeUrlPipe } from '../../../pipes/safe-url.pipe';

@Component({
    selector: 'app-invoice',
    standalone: true,
    imports: [CommonModule, NgxBarcode6, SafeUrlPipe],
    templateUrl: './invoice.html',
    styleUrl: './invoice.scss',
})
export class Invoice implements OnInit {
    isBrowser = false;
    invoiceDataInput = input<any>(null);
    internalInvoiceData = signal<PaymentResponseData | null>(null);
    invoiceData = computed(() => this.invoiceDataInput() || this.internalInvoiceData());
    isModal = input<boolean>(false);

    fedexLabels = computed(() => {
        const data = this.invoiceData();
        if (!data?.fedex_files) return [];
        return data.fedex_files
            .map((f: any) => f.label_url)
            .filter((url: string) => !!url);
    });

    public tenantConfigService = inject(TenantConfigService);
    public settings = this.tenantConfigService.settings;

    constructor(
        @Inject(PLATFORM_ID) private platformId: Object
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit(): void {
        if (this.isBrowser && !this.isModal()) {
            this.loadInvoiceData();
        }
    }

    private loadInvoiceData(): void {
        const saved = localStorage.getItem('payment_response');
        if (saved) {
            try {
                const parsed = JSON.parse(saved);
                if (parsed?.cart) {
                    this.internalInvoiceData.set(parsed.cart);
                }
            } catch (e) {
                console.error('Failed to parse payment_response from local storage', e);
            }
        }
    }

    getDocCount(): number {
        const data = this.invoiceData();
        if (!data) return 0;
        return data.cartItems.reduce((sum: number, item: any) => sum + item.count, 0);
    }

    getSubtotal(): number {
        const data = this.invoiceData();
        if (!data) return 0;
        return data.cartItems.reduce((sum: number, item: any) => sum + parseFloat(item.total_fee), 0);
    }

    getGrandTotal(): number {
        const data = this.invoiceData();
        if (!data) return 0;
        const subtotal = this.getSubtotal();
        const handling = data.handling_fees || 0;
        const fedex = data.fedex_total_fees || 0;
        return subtotal + handling + fedex;
    }

    printInvoice(): void {
        window.print();
    }
}
